
import Promise from "plugins/bluebird"

import {
  q_ajax_3,
  ERROR_HANDLER_ACTIONS as AJAX_ERROR_HANDLER_ACTIONS,
} from "app/utils/q_ajax/q_ajax_3"

interface Inputs {
  id: string | number,
}

/* eslint-disable no-unused-vars */
enum ResultTypeEnums {
  SUCCESS =            "SUCCESS",
  RESOURCE_NOT_FOUND = "RESOURCE_NOT_FOUND",
  INPUTS_INVALID =     "INPUTS_INVALID",
  SERVER_ERROR =       "SERVER_ERROR",
}
/* eslint-enable no-unused-vars */

interface ListingDetails {
  id: string,

  is_rental: boolean,
  is_commercial_listing: boolean,

  is_for_serviced_apartment:    boolean,
  for_overseas_marketing_only:  boolean,

  is_for_business_center:       boolean,
  is_for_serviced_office:       boolean,
  is_for_coworking_space:       boolean,

  is_for_coliving_space:        boolean,
}

interface PromiseResolvePayload {
  result_type: ResultTypeEnums,
  data?: ListingDetails,
}

const get_one = (inputs: Inputs): Promise<PromiseResolvePayload> => {
  return Promise.resolve(
    import(
      "plugins/js-routes"
    )
  )
  .then((Routes) => {
    return q_ajax_3(
      {
        // Routes don't encode input automatically
        url: Routes.get_one_api_web_app_listing_path({
          id: encodeURIComponent(inputs.id),
        }),
        method:   "GET",
        dataType: "json",
      },
      {
        custom_error_handler: ({http_status_code}) => {
          if (http_status_code === 404) {
            return AJAX_ERROR_HANDLER_ACTIONS.STOP_RETRY
          }
          if (http_status_code === 422) {
            return AJAX_ERROR_HANDLER_ACTIONS.STOP_RETRY
          }

          return AJAX_ERROR_HANDLER_ACTIONS.CONTINUE_RETRY
        },
      },
    )
  })
  .then(({data}) => {
    return (
      {
        result_type: ResultTypeEnums.SUCCESS,

        data: {
          id: data.data.id,

          is_rental:              data.data.is_rental,
          is_commercial_listing:  data.data.is_commercial_listing,

          is_for_serviced_apartment:    data.data.is_for_serviced_apartment,
          for_overseas_marketing_only:  data.data.for_overseas_marketing_only,

          is_for_business_center:       data.data.is_for_business_center,
          is_for_serviced_office:       data.data.is_for_serviced_office,
          is_for_coworking_space:       data.data.is_for_coworking_space,

          is_for_coliving_space:        data.data.is_for_coliving_space,
        },
      }
    )
  })
  .catch((reason_or_error) => {
    if (reason_or_error instanceof Error) {
      throw reason_or_error
    }

    const { response } = reason_or_error
    switch (response.status) {
      case 500:
      case 502:
      case 503:
      case 504:
        return ({result_type: ResultTypeEnums.SERVER_ERROR})
      case 404:
        return ({result_type: ResultTypeEnums.RESOURCE_NOT_FOUND})
      case 422:
        return ({result_type: ResultTypeEnums.RESOURCE_NOT_FOUND})
      default:
        return ({result_type: ResultTypeEnums.INPUTS_INVALID})
    }
  })
}

export {
  get_one,
  ResultTypeEnums,
}
